import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import defaultuniversity from "assets/images/university/defaultuniversity.png";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAdduniversityMutation } from "store/api/universities.api";
import { handleFileUpload } from "services/UploadImage";
import { useUploadmediaMutation } from "store/api/universities.api";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import validator from "validator";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetuniversitydetailsQuery } from "store/api/universities.api";
import { FadeLoader } from "react-spinners";
import { useEdituniversityMutation } from "store/api/universities.api";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import schema from "validationSchema/adduniversity";

function AddUniversity() {
  const [imageFile, setImagefile] = useState(null);
  const [profileImagebob, setProfileImagebob] = useState(null);
  const [form, setForm] = useState({
    university_name: "",
    university_domain: "",
    university_image: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const backPath = location.state?.from || "/schools";
  const logout = useLogout();
  const [uploadmedia] = useUploadmediaMutation();
  const [adduniversity] = useAdduniversityMutation();
  const [edituniversity] = useEdituniversityMutation();

  const {
    data: universityData,
    isLoading: UniversityLoading,
    isFetching,
    error: UniversityError,
    refetch,
  } = useGetuniversitydetailsQuery(id ? { school_id: id } : skipToken);

  // getting  the university data if edit univeisty or id present

  useEffect(() => {
    if (universityData?.status === 1) {
      const { school_name, school_image, school_domain } = universityData?.data;
      setForm({
        university_name: school_name || "",
        university_domain: school_domain || "",
        university_image: school_image || "",
      });
    } else if (universityData?.status == 0) {
      toast?.error(universityData?.message);
    } else if (universityData?.status == 10) {
      logout();
    }
  }, [universityData]);

  // handle image file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImagefile(file);
      const imageUrl = URL.createObjectURL(file);
      setProfileImagebob(imageUrl);
    }
  };

  // handle change the innput fields
  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // validate the form
  const validateForm = () => {
    const requiredFields = {
      university_image: id ? form?.university_image : imageFile,
      university_name: form?.university_name,
      university_domain: form?.university_domain,
    };

    const result = schema.safeParse(requiredFields);

    if (!result.success) {
      const zodErrors = JSON.parse(result.error.message) ?? [];

      const firstMessage = zodErrors[0]?.message;
      if (firstMessage) {
        toast.error(firstMessage);
        return false;
      }
    } else {
      return true;
    }

  };

  // handle submit
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);

    let data = {
      school_name: form?.university_name,
      school_domain: form?.university_domain,
      school_image: form?.university_image,
    };

    // uploade the  image on the cloudinary
    if (imageFile) {
      const result = await handleFileUpload(imageFile, "school_images", uploadmedia);
      if (result?.success) {
        data = { ...data, school_image: result?.imageUrl };
      } else {
        setLoading(false);
        return;
      }
    }

    if (id) {
      data = { ...data, school_id: id };
    }

    try {
      const response = id
        ? await edituniversity(data).unwrap()
        : await adduniversity(data).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message));
        id ? navigate(`/school-details/${id}`) : navigate(backPath);
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (universityData?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. please try again in a few minutes.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox
        sx={{
          pr: { xs: 1, sm: 2, md: 4 },
          pl: { xs: 1, sm: 2, md: 2 },
          top: { xs: "55%", sm: "40%" },
        }}
        position="absolute"
        width="100%"
      >
        {UniversityLoading || isFetching ? (
          <SoftBox
            sx={{
              height: "calc(70vh)",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FadeLoader color="#3DC2EB" />
          </SoftBox>
        ) : (
          <SoftBox
            width="100%"
            display="flex"
            sx={{ px: { xs: 1, sm: 2, md: 10, lg: 20, xl: 25 }, pb: 4 }}
          >
            <SoftBox
              sx={{ backgroundColor: "white.main", px: { xs: 1, sm: 2, md: 5, lg: 20 }, py: 4 }}
              border="1px solid #D8E0E8"
              borderRadius="md"
              display="flex"
              alignItems="start"
              justifyContent="center"
              width="100%"
            >
              <SoftBox display="flex" sx={{ width: "100%", flexDirection: "column", gap: 2 }}>
                <SoftBox
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ flexDirection: "column" }}
                >
                  <SoftBox
                    height="160px"
                    width="160px"
                    borderRadius="lg"
                    border="1px solid #D8E0E8"
                    sx={{
                      backgroundImage: `url(${
                        profileImagebob
                          ? profileImagebob
                          : form?.university_image
                          ? form?.university_image
                          : defaultuniversity
                      })`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                      p: 1,
                    }}
                  />

                  <SoftBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                    {/* Hidden file input */}
                    <input
                      accept="image/*"
                      id="upload-photo"
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e)}
                    />

                    <label
                      htmlFor="upload-photo"
                      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    >
                      <LogoutIcon sx={{ color: "primary.main", transform: "rotate(270deg)" }} />
                      <SoftTypography sx={{ fontSize: 20, color: "primary.main", pl: 1 }}>
                        Choose Image
                      </SoftTypography>
                    </label>
                  </SoftBox>
                </SoftBox>

                <SoftBox width="100%" align="center">
                  <SoftTypography sx={{ fontSize: 12 }}>
                    {id
                      ? "Update the school information below. Ensure all details are correct and reflect the most recent data."
                      : " Enter the details below to register a new school in the system. Make sure the information is accurate and up to date"}
                  </SoftTypography>
                </SoftBox>

                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography sx={{ fontSize: 16 }} color="darkgray" fontWeight="medium">
                    School Name
                  </SoftTypography>

                  <SoftInput
                    name="university_name"
                    value={form?.university_name}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    placeholder="Enter school name"
                    fontSize="14px"
                    sx={{
                      width: "100% !important",
                      py: "15px",

                      "& .MuiInputBase-input::placeholder": {
                        color: "#b4bbc6ff !important",
                      },
                    }}
                  />
                </SoftBox>

                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography sx={{ fontSize: 16 }} color="darkgray" fontWeight="medium">
                    School Domain
                  </SoftTypography>

                  <SoftInput
                    name="university_domain"
                    value={form?.university_domain}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    placeholder="Enter school domain"
                    fontSize="14px"
                    sx={{
                      width: "100% !important",
                      py: "15px",

                      "& .MuiInputBase-input::placeholder": {
                        color: "#b4bbc6ff !important",
                      },
                    }}
                  />
                </SoftBox>

                <SoftBox display="flex" alignItems="start" justifyContent="center">
                  <SoftButton
                    onClick={handleSubmit}
                    disabled={loading}
                    color="primary"
                    fontWeight="normal"
                    variant="contained"
                    sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                  >
                    {loading ? "Loading..." : id ? "Update Details" : "Add School"}
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        )}
      </SoftBox>
    </DashboardLayout>
  );
}

export default AddUniversity;
